<template>
  <div class="container mx-auto h-full py-5">
    <ul class="grid grid-cols-12 gap-4">
      <li
        v-for="report in reports"
        :key="report.id"
        :class="
          report.disabled
            ? 'border-gray-400 text-gray-400'
            : 'border-orange-200 hover:border-blue-200 cursor-pointer hover:shadow-lg text-orange-800 hover:text-blue-800'
        "
        class="flex flex-col space-y-2 border rounded-md p-4 col-span-4"
        @click="generate(report.action)"
      >
        <div class="flex flex-row justify-between">
          <span class="font-semibold text-sm">{{ report.name }}</span>
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-html="report.icon"
          />
        </div>
        <span class="text-gray-700">{{ report.description }}</span>
      </li>
    </ul>

    <el-dialog
      title="Planilla general"
      :visible.sync="showPlanillaGeneralDialog"
      width="30%"
    >
      <el-form
        status-icon
        :model="planillaGeneralOptions"
        ref="generatePlanillaGeneralReport"
        @submit.native.prevent="
          generatePlanillaGeneralReport(planillaGeneralOptions)
        "
        class="space-y-4"
      >
        <div v-loading="planillaGeneralDataLoading">
          <el-row :gutter="15">
            <el-col :span="7">
              <el-form-item label="Seleccione tipo" prop="user">
                <el-select
                  v-model="planillaGeneralOptions.type"
                  placeholder="Seleccionar tipo"
                  size="small"
                  filterable
                  class="w-full"
                >
                  <el-option
                    v-for="o in planillaGeneralTypes"
                    :key="o.id"
                    :label="o.name"
                    :value="o.id"
                    :disabled="o.disabled"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Seleccione la planilla" prop="user">
                <el-select
                  v-model="planillaGeneralOptions.selectedPaysheet"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="
                    planillaGeneralPaysheetChange(
                      planillaGeneralOptions.selectedPaysheet
                    )
                  "
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="Exportar a:" prop="user">
                <el-radio-group
                  v-model="planillaGeneralOptions.export"
                  class="w-full"
                  :disabled="planillaGeneralOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="12">
                      <el-radio border size="small" label="pdf" class="w-full"
                        >PDF</el-radio
                      >
                    </el-col>
                    <el-col :span="12">
                      <el-radio border size="small" label="excel" class="w-full"
                        >EXCEL</el-radio
                      >
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" class="flex justify-end">
              <el-button size="small" @click="showPlanillaGeneralDialog = false"
                >Cancelar</el-button
              >
              <el-button size="small" type="primary" native-type="submit">
                <i class="el-icon-download"></i> Descargar
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- PARA BOLETAS DE PAGO -->
    <el-dialog
      title="Imprimir Boletas de pago"
      :visible.sync="showPrintPayStub"
      width="30%"
    >
      <el-form
        status-icon
        :model="payStubPrintOptions"
        ref="printPayStub"
        @submit.native.prevent="printBoletas(payStubPrintOptions)"
        class="space-y-4"
      >
        <div v-loading="payStubDataLoading">
          <el-row>
            <el-col :span="10">
              <el-form-item label="Seleccione la planilla" prop="user">
                <el-select
                  v-model="payStubPrintOptions.selectedPaysheet"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="
                    payStubPaysheetChange(payStubPrintOptions.selectedPaysheet)
                  "
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item label="Seleccione una opcion" prop="user">
                <el-radio-group
                  v-model="payStubPrintOptions.type"
                  class="w-full"
                  @change="payStubPrintOptions.selection = []"
                  :disabled="payStubPrintOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" :label="1" class="w-full"
                        >Todas las boletas</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="2" class="w-full"
                        >Departamento(s)</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="3" class="w-full"
                        >Empleados</el-radio
                      >
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" v-if="payStubPrintOptions.type == 2">
              <el-form-item label="Seleccionar departamentos">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="payStubPrintOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in payStubDataDepartments"
                    :key="d"
                    :label="d"
                    :value="d"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="payStubPrintOptions.type == 3">
              <el-form-item label="Seleccionar empleados">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="payStubPrintOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in payStubDataEmployees"
                    :key="d.id"
                    :label="d.fullname"
                    :value="d.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" class="flex justify-end">
              <el-button size="small" @click="showPrintPayStub = false"
                >Cancelar</el-button
              >
              <el-button size="small" type="primary" native-type="submit">
                <i class="el-icon-printer"></i> Imprimir
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- PARA GRATIFICANONES -->
    <el-dialog
      title="Listado de gratificaciones"
      :visible.sync="showGratificationDialog"
      width="30%"
    >
      <el-form
        status-icon
        :model="gratificationsOptions"
        ref="generateGratificationReport"
        @submit.native.prevent="
          generateGratificationReport(gratificationsOptions)
        "
        class="space-y-4"
      >
        <div v-loading="gratificationsDataLoading">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Seleccione la planilla" prop="user">
                <el-select
                  v-model="gratificationsOptions.selectedPaysheet"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="
                    gratificationsPaysheetChange(
                      gratificationsOptions.selectedPaysheet
                    )
                  "
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="Exportar a:" prop="user">
                <el-radio-group
                  v-model="gratificationsOptions.export"
                  class="w-full"
                  :disabled="gratificationsOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" label="pdf" class="w-full"
                        >PDF</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" label="excel" class="w-full"
                        >EXCEL</el-radio
                      >
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item label="Seleccione una opcion" prop="user">
                <el-radio-group
                  v-model="gratificationsOptions.type"
                  class="w-full"
                  @change="gratificationsOptions.selection = []"
                  :disabled="gratificationsOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" :label="1" class="w-full"
                        >Todos los empleados</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="2" class="w-full"
                        >Por departamento(s)</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="3" class="w-full"
                        >Empleados especificos</el-radio
                      >
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" v-if="gratificationsOptions.type == 2">
              <el-form-item label="Seleccionar departamentos">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="gratificationsOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in gratificationsDataDepartments"
                    :key="d"
                    :label="d"
                    :value="d"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="gratificationsOptions.type == 3">
              <el-form-item label="Seleccionar empleados">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="gratificationsOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in gratificationsDataEmployees"
                    :key="d.id"
                    :label="d.fullname"
                    :value="d.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" class="flex justify-end">
              <el-button size="small" @click="showGratificationDialog = false"
                >Cancelar</el-button
              >
              <el-button size="small" type="primary" native-type="submit">
                <i class="el-icon-download"></i> Descargar
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- PARA DESCUENTOS -->
    <el-dialog
      title="Listado de descuentos"
      :visible.sync="showDiscountDialog"
      width="30%"
    >
      <el-form
        status-icon
        :model="discountsOptions"
        ref="generateDiscountReport"
        @submit.native.prevent="generateDiscountReport(discountsOptions)"
        class="space-y-4"
      >
        <div v-loading="discountsDataLoading">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Seleccione la planilla" prop="user">
                <el-select
                  v-model="discountsOptions.selectedPaysheet"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="
                    discountsPaysheetChange(discountsOptions.selectedPaysheet)
                  "
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="Exportar a:" prop="user">
                <el-radio-group
                  v-model="discountsOptions.export"
                  class="w-full"
                  :disabled="discountsOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" label="pdf" class="w-full"
                        >PDF</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" label="excel" class="w-full"
                        >EXCEL</el-radio
                      >
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item label="Seleccione una opcion" prop="user">
                <el-radio-group
                  v-model="discountsOptions.type"
                  class="w-full"
                  @change="discountsOptions.selection = []"
                  :disabled="discountsOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" :label="1" class="w-full"
                        >Todos los empleados</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="2" class="w-full"
                        >Por departamento(s)</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="3" class="w-full"
                        >Empleados especificos</el-radio
                      >
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" v-if="discountsOptions.type == 2">
              <el-form-item label="Seleccionar departamentos">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="discountsOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in discountsDataDepartments"
                    :key="d"
                    :label="d"
                    :value="d"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="discountsOptions.type == 3">
              <el-form-item label="Seleccionar empleados">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="discountsOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in discountsDataEmployees"
                    :key="d.id"
                    :label="d.fullname"
                    :value="d.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" class="flex justify-end">
              <el-button size="small" @click="showDiscountDialog = false"
                >Cancelar</el-button
              >
              <el-button size="small" type="primary" native-type="submit">
                <i class="el-icon-download"></i> Descargar
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- PARA RENTA -->
    <el-dialog
      title="Reporte de renta"
      :visible.sync="showReporteRentaDialog"
      width="30%"
    >
      <el-form
        status-icon
        :model="reporteRentaOptions"
        ref="generateRentaReport"
        @submit.native.prevent="generateRentaReport(reporteRentaOptions)"
        class="space-y-4"
      >
        <div v-loading="reporteRentaDataLoading">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Seleccione tipo de reporte">
                <el-select
                  v-model="reporteRentaOptions.reportType"
                  size="small"
                  class="w-full"
                >
                  <el-option label="Planilla" value="1" />
                  <el-option label="Mensual" value="2" :disabled="true" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Seleccione la planilla">
                <el-select
                  v-model="reporteRentaOptions.selectedPaysheet"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="
                    rentaReportePaysheetChange(
                      reporteRentaOptions.selectedPaysheet
                    )
                  "
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="Exportar a:" prop="user">
                <el-radio-group
                  v-model="reporteRentaOptions.export"
                  class="w-full"
                  :disabled="reporteRentaOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" label="pdf" class="w-full">
                        PDF
                      </el-radio>
                    </el-col>
                    <el-col :span="8">
                      <el-radio
                        border
                        size="small"
                        label="excel"
                        class="w-full"
                      >
                        EXCEL
                      </el-radio>
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item label="Seleccione una opcion" prop="user">
                <el-radio-group
                  v-model="reporteRentaOptions.type"
                  class="w-full"
                  @change="reporteRentaOptions.selection = []"
                  :disabled="reporteRentaOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" :label="1" class="w-full">
                        Todos los empleados
                      </el-radio>
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="2" class="w-full">
                        Por departamento(s)
                      </el-radio>
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="3" class="w-full">
                        Empleados especificos
                      </el-radio>
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" v-if="reporteRentaOptions.type == 2">
              <el-form-item label="Seleccionar departamentos">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="reporteRentaOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in reporteRentaDepartments"
                    :key="d"
                    :label="d"
                    :value="d"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="reporteRentaOptions.type == 3">
              <el-form-item label="Seleccionar empleados">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="reporteRentaOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in reporteRentaEmployees"
                    :key="d.id"
                    :label="d.fullname"
                    :value="d.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" class="flex justify-end">
              <el-button size="small" @click="showReporteRentaDialog = false">
                Cancelar
              </el-button>
              <el-button size="small" type="primary" native-type="submit">
                <i class="el-icon-download"></i> Descargar
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- PARA HORAS EXTRA -->
    <el-dialog
      title="Listado de horas extra"
      :visible.sync="showOvertimeDialog"
      width="30%"
    >
      <el-form
        status-icon
        :model="overtimeOptions"
        ref="generateOvertimeReport"
        @submit.native.prevent="generateOvertimeReport(overtimeOptions)"
        class="space-y-4"
      >
        <div v-loading="overtimeDataLoading">
          <el-row :gutter="15">
            <el-col :span="10">
              <!-- <el-form-item label="Seleccione tipo de reporte" prop="user">
                <el-select
                  v-model="overtimeOptions.reportType"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="overtimeReportTypeChange(overtimeOptions.reportType)"
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="10"> -->
              <el-form-item label="Seleccione la planilla" prop="user">
                <el-select
                  v-model="overtimeOptions.selectedPaysheet"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="
                    overtimePaysheetChange(overtimeOptions.selectedPaysheet)
                  "
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="Exportar a:" prop="user">
                <el-radio-group
                  v-model="overtimeOptions.export"
                  class="w-full"
                  :disabled="overtimeOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" label="pdf" class="w-full"
                        >PDF</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" label="excel" class="w-full"
                        >EXCEL</el-radio
                      >
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item label="Seleccione una opcion" prop="user">
                <el-radio-group
                  v-model="overtimeOptions.type"
                  class="w-full"
                  @change="overtimeOptions.selection = []"
                  :disabled="overtimeOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" :label="1" class="w-full"
                        >Todos los empleados</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="2" class="w-full"
                        >Por departamento(s)</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="3" class="w-full"
                        >Empleados especificos</el-radio
                      >
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" v-if="overtimeOptions.type == 2">
              <el-form-item label="Seleccionar departamentos">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="overtimeOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in overtimeDataDepartments"
                    :key="d"
                    :label="d"
                    :value="d"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="overtimeOptions.type == 3">
              <el-form-item label="Seleccionar empleados">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="overtimeOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in overtimeDataEmployees"
                    :key="d.id"
                    :label="d.fullname"
                    :value="d.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" class="flex justify-end">
              <el-button size="small" @click="showOvertimeDialog = false"
                >Cancelar</el-button
              >
              <el-button size="small" type="primary" native-type="submit">
                <i class="el-icon-download"></i> Descargar
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- PARA PAGO ELECTRONICO -->
    <el-dialog
      title="Pago electronico 1.0"
      :visible.sync="showPagoElectronicoDialog"
      width="30%"
    >
      <el-form
        status-icon
        :model="pagoElectronicoOptions"
        ref="generatePagoElectronicoReport"
        @submit.native.prevent="
          generatePagoElectronicoReport(pagoElectronicoOptions)
        "
        class="space-y-4"
      >
        <div v-loading="pagoElectronicoDataLoading">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Seleccione la planilla" prop="user">
                <el-select
                  v-model="pagoElectronicoOptions.selectedPaysheet"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="
                    pagoElectronicoPaysheetChange(
                      pagoElectronicoOptions.selectedPaysheet
                    )
                  "
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="Exportar a:" prop="user">
                <el-radio-group
                  v-model="pagoElectronicoOptions.export"
                  class="w-full"
                  :disabled="pagoElectronicoOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" label="pdf" class="w-full"
                        >PDF</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" label="excel" class="w-full"
                        >CSV</el-radio
                      >
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item label="Seleccione una opcion" prop="user">
                <el-radio-group
                  v-model="pagoElectronicoOptions.type"
                  class="w-full"
                  @change="pagoElectronicoOptions.selection = []"
                  :disabled="pagoElectronicoOptions.selectedPaysheet == ''"
                >
                  <el-row :gutter="15">
                    <el-col :span="8">
                      <el-radio border size="small" :label="1" class="w-full"
                        >Todos los empleados</el-radio
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-radio border size="small" :label="2" class="w-full"
                        >Por departamento(s)</el-radio
                      >
                    </el-col>
                    <!-- <el-col :span="8">
                      <el-radio border size="small" :label="3" class="w-full"
                        >Empleados especificos</el-radio
                      >
                    </el-col> -->
                  </el-row>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" v-if="pagoElectronicoOptions.type == 2">
              <el-form-item label="Seleccionar departamentos">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="pagoElectronicoOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in pagoElectronicoDataDepartments"
                    :key="d"
                    :label="d"
                    :value="d"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="pagoElectronicoOptions.type == 3">
              <el-form-item label="Seleccionar empleados">
                <el-select
                  remote
                  filterable
                  multiple
                  clearable
                  v-model="pagoElectronicoOptions.selection"
                  placeholder="Select"
                  class="w-full"
                  size="small"
                >
                  <el-option
                    v-for="d in pagoElectronicoDataEmployees"
                    :key="d.id"
                    :label="d.fullname"
                    :value="d.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" class="flex justify-end">
              <el-button size="small" @click="showPagoElectronicoDialog = false"
                >Cancelar</el-button
              >
              <el-button size="small" type="primary" native-type="submit">
                <i class="el-icon-download"></i> Descargar
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- PARA RESUMEN DE PLANILLA -->
    <el-dialog
      title="Resumen de planilla"
      :visible.sync="showResumenDePlanillaDialog"
      width="30%"
    >
      <el-form
        status-icon
        :model="resumenPlanillaOptions"
        ref="generateResumenPlanillaReport"
        @submit.native.prevent="
          generateResumenDePlanillaReport(resumenPlanillaOptions)
        "
        class="space-y-4"
      >
        <div v-loading="resumenPlanillaDataLoading">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Seleccione la planilla" prop="user">
                <el-select
                  v-model="resumenPlanillaOptions.selectedPaysheet"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="
                    discountsPaysheetChange(
                      resumenPlanillaOptions.selectedPaysheet
                    )
                  "
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" class="flex justify-end">
              <el-button
                size="small"
                @click="showResumenDePlanillaDialog = false"
                >Cancelar</el-button
              >
              <el-button size="small" type="primary" native-type="submit">
                <i class="el-icon-download"></i> Descargar
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- PARA DATOS DE PLANILLA MENSUAL -->
    <el-dialog
      title="Datos de planilla mensual"
      :visible.sync="showPlanillaMensualDialog"
      width="30%"
    >
      <el-form
        status-icon
        :model="planillaMensualOptions"
        ref="generatePlanillaMensualReport"
        @submit.native.prevent="
          generatePlanillaMensualReport(planillaMensualOptions)
        "
        class="space-y-4"
      >
        <div v-loading="planillaMensualDataLoading">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="Seleccione la planilla" prop="user">
                <el-select
                  v-model="planillaMensualOptions.selectedPaysheet"
                  placeholder="Seleccionar nómina"
                  size="small"
                  filterable
                  class="w-full"
                  @change="
                    planillaMensualPaysheetChange(
                      planillaMensualOptions.selectedPaysheet
                    )
                  "
                >
                  <el-option
                    v-for="o in paysheets"
                    :key="o.id"
                    :label="o.code"
                    :value="o.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24" class="flex justify-end">
              <el-button
                size="small"
                @click="showPlanillaMensualDialog = false"
              >
                Cancelar
              </el-button>
              <el-button size="small" type="primary" native-type="submit">
                <i class="el-icon-download"></i> Descargar
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import { format, differenceInYears, getDay, setYear } from "date-fns";
import XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  getHeader,
  getFooter,
  formatMoney,
  printBoleta,
  formatName,
} from "../../../utils";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "GeneralData",
  data() {
    return {
      // DATOS GENERALES
      paysheets: [],
      meses: [
        { number: "01", name: "Enero" },
        { number: "02", name: "Febrero" },
        { number: "03", name: "Marzo" },
        { number: "04", name: "Abril" },
        { number: "05", name: "Mayo" },
        { number: "06", name: "Junio" },
        { number: "07", name: "Julio" },
        { number: "08", name: "Agosto" },
        { number: "09", name: "Septiembre" },
        { number: "10", name: "Octubre" },
        { number: "11", name: "Noviembre" },
        { number: "12", name: "Diciembre" },
      ],

      // PARA RENTA
      showReporteRentaDialog: false,
      reporteRentaDataLoading: false,
      reporteRentaOptions: {
        reportType: "1",
        selectedPaysheet: "",
        export: "pdf",
        type: 1,
        selection: [],
      },
      reporteRentaData: [],
      reporteRentaDepartments: [],
      reporteRentaEmployees: [],

      // PARA HORAS EXTRA
      showOvertimeDialog: false,
      overtimeOptions: {
        selectedPaysheet: "",
        selection: "",
        type: 1,
        export: "pdf",
        // reportType: "quincenal",
      },
      overtimeDataLoading: false,
      overtimeDataDepartments: [],
      overtimeDataEmployees: [],
      overtimeData: [],
      overtimeList: [],

      // PARA DESCUENTOS
      showDiscountDialog: false,
      discountsOptions: {
        selectedPaysheet: "",
        selection: "",
        type: 1,
        export: "pdf",
      },
      discountsDataLoading: false,
      discountsDataDepartments: [],
      discountsDataEmployees: [],
      discountsData: [],
      discountsList: [],

      // PARA GRATIFICACIONES
      showGratificationDialog: false,
      gratificationsOptions: {
        selectedPaysheet: "",
        selection: "",
        type: 1,
        export: "pdf",
      },
      gratificationsDataLoading: false,
      gratificationsDataDepartments: [],
      gratificationsDataEmployees: [],
      gratificationsData: [],
      gratificationsList: [],

      // PARA RESUMEN PLANIALLAS
      showResumenDePlanillaDialog: false,
      resumenPlanillaOptions: {
        selectedPaysheet: "",
      },
      resumenPlanillaDataLoading: false,

      // PARA BOLETAS DE PAGO
      showPrintPayStub: false,
      payStubSelectionOptions: [],
      payStubPrintOptions: {
        selectedPaysheet: "",
        selection: "",
        type: 1,
      },
      payStubData: [],
      payStubDataDepartments: [],
      payStubDataEmployees: [],
      payStubDataLoading: false,

      // PARA PAGO ELECTRONICO
      showPagoElectronicoDialog: false,
      pagoElectronicoOptions: {
        selectedPaysheet: "",
        selection: "",
        type: 1,
        export: "pdf",
      },
      pagoElectronicoDataLoading: false,
      pagoElectronicoDataDepartments: [],
      pagoElectronicoDataEmployees: [],
      pagoElectronicoData: [],

      // PARA PLANILLA GENERAL
      showPlanillaGeneralDialog: false,
      planillaGeneralOptions: {
        selectedPaysheet: "",
        type: "ordinaria",
        export: "pdf",
      },
      planillaGeneralDataLoading: false,
      planillaGeneralTypes: [
        { id: "ordinaria", name: "Planilla ordinaria", disabled: false },
        { id: "aguinaldos", name: "Planilla de aguinaldos", disabled: true },
        { id: "bonos", name: "Planilla de bonos", disabled: true },
      ],
      planillaGeneralData: [],

      // PARA DATOS DE PLANILLA MENSUAL
      showPlanillaMensualDialog: false,
      planillaMensualOptions: {
        selectedPaysheet: "",
      },
      planillaMensualDataLoading: false,
      planillaMensualData: [],

      reports: [
        {
          id: "pgeneral",
          name: "PLANILLA GENERAL",
          action: "pgeneral",
          description:
            "Planilla Ordinaria - Planilla de Aguinaldos - Planilla de Bonos ",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
        {
          id: "bpago",
          name: "BOLETAS DE PAGO",
          action: "bpago",
          description:
            "Se pueden descargar todas las boletas de pago, por empleado o por departamento de la planilla que se desee.",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
        {
          id: "resplanilla",
          name: "RESUMEN DE PLANILLA",
          action: "resplanilla",
          description: "RESUMEN DE PLANILLA ",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
        {
          id: "discounts",
          name: "LISTADO DE DESCUENTOS",
          action: "discounts",
          description:
            "Reporte que detalla todos los descuentos aplicados a un empleado en una planilla especifica",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
        {
          id: "gratifications",
          name: "LISTADO DE GRATIFICACIONES",
          action: "gratifications",
          description:
            "Reporte que detalla todas las gratificaciones aplicadas a un empleado en una planilla especifica",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
        {
          id: "hextras",
          name: "HORAS EXTRAS",
          action: "hextras",
          description: "HORAS EXTRAS",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
        {
          id: "pelectronico",
          name: "PAGO ELECTRÓNICO",
          action: "pelectronico",
          description: "PAGO ELECTRÓNICO",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
        {
          id: "rrenta",
          name: "REPORTE DE RENTA",
          action: "rrenta",
          description:
            "Esta opción permite descagar 2 tipos de reporte por planilla y de manera mensual. 1) Reporte de descuentos de renta según tabla y 2) Reporte de descuentos de renta 10%. Todos pueden ser exportados en EXCEL o PDF.",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
        {
          id: "risss",
          name: "REPORTE IGSS",
          action: "risss",
          description: "REPORTE IGSS",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "rafp",
          name: "REPORTE AFP",
          action: "rafp",
          description: "REPORTE AFP",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "ahe",
          name: "ANÁLISIS DE HORAS EXTRAS ",
          action: "ahe",
          description: "ANÁLISIS DE HORAS EXTRAS ",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "dmensual",
          name: "DATOS DE PLANILLA MENSUAL",
          action: "dmensual",
          description: "DATOS DE PLANILLA MENSUAL",
          icon:
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: false,
        },
      ],
    };
  },
  methods: {
    fetchPaysheets() {
      axios
        .post("/", {
          query: `{
            paysheets (where: {active: false}) { id code startDate endDate month year paysheetType { type } sequence }
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.paysheets = data.paysheets
              .sort((a, b) => {
                if (a.startDate < b.startDate) return 1;
                if (a.startDate > b.startDate) return -1;
                return 0;
              })
              .map((p) => {
                return {
                  ...p,
                  startDate: format(p.startDate, "DD/MM/YYYY"),
                  endDate: format(p.endDate, "DD/MM/YYYY"),
                  startDateRaw: new Date(p.startDate),
                  endDateRaw: new Date(p.endDate),
                };
              });
          }
        });
    },
    generate(action) {
      switch (action) {
        case "pgeneral":
          this.openForPlanillaGeneral();
          break;
        case "bpago":
          this.openForPayStub();
          break;
        case "resplanilla":
          this.openForResumenDePlanilla();
          break;
        case "discounts":
          this.openForDiscounts();
          break;
        case "gratifications":
          this.openForGratifications();
          break;
        case "hextras":
          this.openForOvertime();
          break;
        case "pelectronico":
          this.openForPagoElectronico();
          break;
        case "dmensual":
          this.openForPlanillaMensual();
          break;
        case "rrenta":
          this.openForRentaReporte();
          break;
      }
    },

    // FOR RENTA
    async openForRentaReporte() {
      await this.fetchPaysheets();
      this.showReporteRentaDialog = true;
    },
    rentaReportePaysheetChange(selectedPaysheet) {
      this.reporteRentaDataLoading = true;
      axios
        .post("/", {
          query: `{
            paysheetHistory (where: {paysheet: ${selectedPaysheet}}) {
              id
              code
              fullName
              taxes
              priorDepartment
              employee {
                name1, name2, name3, lastname1, lastname2, lastname3
              }
            }
            personalActionHistory (where: {paysheet: ${selectedPaysheet}} in: {personalAction: [139, 140, 141]}) {
              employee { code }
              personalAction { id }
              value
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          this.reporteRentaData = data.paysheetHistory.map((h, index) => {
            const personalActions = data.personalActionHistory.filter(
              (pa) => pa.employee.code == h.code
            );
            const taxes10 =
              personalActions.reduce((a, b) => a + b.value, 0) * 0.0;
            return {
              ...h,
              personalActions,
              taxesTotal: h.taxes,
              taxesTable: h.taxes - taxes10,
              taxes10,
            };
          });
          this.reporteRentaDepartments = [
            ...new Set(data.paysheetHistory.map((ph) => ph.priorDepartment)),
          ].filter((e) => e != "null");
          this.reporteRentaEmployees = data.paysheetHistory.map((ph) => ({
            id: ph.id,
            fullname: ph.fullName.split("  ").join(" "),
          }));
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(err.message);
        })
        .then((alw) => {
          this.reporteRentaDataLoading = false;
        });
    },
    generateRentaReport(options) {
      const paysheet = this.paysheets.find(
        (p) => p.id == options.selectedPaysheet
      );

      let data = [];
      switch (options.type) {
        case 1: // Todos
          data = this.reporteRentaData;
          break;
        case 2: // x Departamento
          data = this.reporteRentaData.filter((d) =>
            options.selection.includes(d.priorDepartment)
          );
          break;
        case 3: // x Empleado
          data = this.reporteRentaData.filter((d) => {
            return options.selection.includes(d.id);
          });
          break;
      }

      switch (options.export) {
        case "pdf":
          //  obtiene la data

          const docDefinition = {
            pageSize: "LETTER",
            pageOrientation: "portrait",
            pageMargins: [20, 80, 20, 40],
            header: getHeader(
              "CALDER, SOCIEDAD ANÓNIMA",
              [paysheet.startDate, paysheet.endDate],
              `PLANILLA No. ${paysheet.code}`,
              "fixed",
              `REPORTE DE RENTA`
            ),
            footer: getFooter(),
            content: [
              {
                style: "tableStyle",
                layout: {
                  defaultBorder: false,
                },
                table: {
                  headerRows: 1,
                  widths: [50, "*", 60, 60, 60],
                  body: [
                    [
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "CODIGO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "NOMBRE",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "RENTA TABLA",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "RENTA 10%",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "RENTA TOTAL",
                        bold: true,
                        alignment: "right",
                      },
                    ],
                    ...data.map((e) => [
                      e.code,
                      formatName(e.employee),
                      { text: formatMoney(e.taxesTable), alignment: "right" },
                      { text: formatMoney(e.taxes10), alignment: "right" },
                      { text: formatMoney(e.taxes), alignment: "right" },
                    ]),
                    [
                      {
                        colSpan: 2,
                        fontSize: 9,
                        text: "TOTALES",
                        bold: true,
                        alignment: "right",
                        border: [false, true, false, false],
                        margin: [0, 0, 0, 50],
                      },
                      {
                        text: "",
                        border: [false, true, false, false],
                        margin: [0, 0, 0, 50],
                      },
                      {
                        fontSize: 9,
                        text: formatMoney(
                          data.reduce((a, b) => a + b.taxesTable, 0)
                        ),
                        bold: true,
                        alignment: "right",
                        border: [false, true, false, false],
                        margin: [0, 0, 0, 50],
                      },
                      {
                        fontSize: 9,
                        text: formatMoney(
                          data.reduce((a, b) => a + b.taxes10, 0)
                        ),
                        bold: true,
                        alignment: "right",
                        border: [false, true, false, false],
                        margin: [0, 0, 0, 50],
                      },
                      {
                        fontSize: 9,
                        text: formatMoney(
                          data.reduce((a, b) => a + b.taxes, 0)
                        ),
                        bold: true,
                        alignment: "right",
                        border: [false, true, false, false],
                        margin: [0, 0, 0, 50],
                      },
                    ],
                    [
                      {
                        colSpan: 5,
                        layout: {
                          defaultBorder: false,
                        },
                        table: {
                          widths: [20, "*", 20, "*", 20, "*", 20],
                          body: [
                            [
                              "",
                              {
                                text: "ELABORADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "REVISADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "AUTORIZADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                            ],
                          ],
                        },
                      },
                    ],
                  ],
                },
              },
            ],
            styles: {
              tableStyle: {
                fontSize: 8.5,
              },
            },
          };
          pdfMake.createPdf(docDefinition).open();
          break;

        case "excel":
          const filename = `reporte-renta-${paysheet.code}-${format(
            new Date(),
            "YYYYMMDDHHmmss"
          )}`;
          const excelValues = [];

          for (const d of data) {
            excelValues.push({
              Codigo: d.code,
              NombreCompleto: formatName(d.employee),
              Departamento: d.priorDepartment,
              RentaTabla: d.taxesTable,
              Renta10: d.taxes10,
              RentaTotal: d.taxes,
            });
          }
          const worksheet = XLSX.utils.json_to_sheet(excelValues);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, worksheet, "Reporte Renta");
          XLSX.writeFile(wb, `${filename}.xlsx`);
          break;
      }
    },

    // FOR PAYSTUB
    async openForPayStub() {
      await this.fetchPaysheets();
      this.showPrintPayStub = true;
    },
    payStubPaysheetChange(selectedPaysheet) {
      this.payStubDataLoading = true;
      axios
        .post("/", {
          query: `{
            paysheetHistory(where:{ paysheet: ${selectedPaysheet} }) {
              id
              fullName
              workedDays
              missedDays
              salary
              salaryForPayroll
              overtime
              gratification
              discounts
              subtotalSalary
              taxes
              socialEmployee
              afpEmployee
              socialEmployer
              afpEmployer
              total
              code
              priorDepartment
            }
            personalActionHistory(where:{ paysheet: ${selectedPaysheet} }) {
              name
              value
              amount
              personalAction { name }
              employee { code }
              PAdeductISR
              type
            }
            overtimeHistory(where:{ paysheet: ${selectedPaysheet} }) {
              hours
              factor
              name
              date
              comment
              employee { code }
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          this.payStubData = data.paysheetHistory.map((h) => {
            const personalActions = data.personalActionHistory.filter(
                (pa) => pa.employee.code == h.code
              ),
              index = index + 1;
            return {
              index: index.toString(),
              ...h,
              workedDays: h.workedDays.toString(),
              gratificationsList: personalActions.filter((pa) => pa.type == 2),
              discountsList: personalActions.filter((pa) => pa.type == 3),
              overtimeList: data.overtimeHistory.filter(
                (o) => o.employee.code == h.code
              ),
            };
          });
          this.payStubDataDepartments = [
            ...new Set(data.paysheetHistory.map((ph) => ph.priorDepartment)),
          ].filter((e) => e != "null");
          this.payStubDataEmployees = data.paysheetHistory.map((ph) => ({
            id: ph.id,
            fullname: ph.fullName.split("  ").join(" "),
          }));
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(err.message);
        })
        .then((alw) => {
          this.payStubDataLoading = false;
        });
    },
    printBoletas(options) {
      // /      XLSX.writeFile(wb, `${filename}.xlsx`);

      printBoleta(
        this.payStubData,
        options,
        this.paysheets.find((p) => p.id == options.selectedPaysheet)
      );
    },

    // PARA DESCUENTOS
    async openForDiscounts() {
      await this.fetchPaysheets();
      this.showDiscountDialog = true;
    },
    discountsPaysheetChange(selectedPaysheet) {
      this.discountsDataLoading = true;
      axios
        .post("/", {
          query: `{
            paysheetHistory(where:{ paysheet: ${selectedPaysheet} }) {
              id
              fullName
              workedDays
              missedDays
              salary
              salaryForPayroll
              overtime
              gratification
              discounts
              subtotalSalary
              taxes
              socialEmployee
              afpEmployee
              socialEmployer
              afpEmployer
              total
              code
              priorDepartment
              priorCostCenter
              employee {
                name1, name2, name3, lastname1, lastname2, lastname3
              }
            }
            personalActionHistory(where:{ paysheet: ${selectedPaysheet} }) {
              name
              value
              amount
              personalAction { id name }
              employee { code }
              PAdeductISR
              type
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          this.discountsData = data.paysheetHistory.map((h) => {
            const personalActions = data.personalActionHistory.filter(
                (pa) => pa.employee.code == h.code
              ),
              index = index + 1;
            return {
              index: index.toString(),
              ...h,
              workedDays: h.workedDays.toString(),
              gratificationsList: personalActions.filter((pa) => pa.type == 2),
              discountsList: personalActions.filter((pa) => pa.type == 3),
            };
          });
          this.discountsDataDepartments = [
            ...new Set(data.paysheetHistory.map((ph) => ph.priorDepartment)),
          ].filter((e) => e != "null");
          this.discountsDataEmployees = data.paysheetHistory.map((ph) => ({
            id: ph.id,
            fullname: ph.fullName.split("  ").join(" "),
          }));
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(err.message);
        })
        .then((alw) => {
          this.discountsDataLoading = false;
        });
    },
    generateDiscountReport(options) {
      const paysheet = this.paysheets.find(
        (p) => p.id == options.selectedPaysheet
      );

      let data = [];
      switch (options.type) {
        case 1: // Todos
          data = this.discountsData;
          break;
        case 2: // x Departamento
          data = this.discountsData.filter((d) =>
            options.selection.includes(d.priorDepartment)
          );
          break;
        case 3: // x Empleado
          data = this.discountsData.filter((d) => {
            return options.selection.includes(d.id);
          });
          break;
      }

      switch (options.export) {
        case "pdf":
          //  obtiene el listado de descuentos
          let discounts = [];
          for (const d of data) {
            discounts = discounts.concat(
              d.discountsList.map((dl) => dl.name.trim())
            );
          }

          discounts = [...new Set(discounts)];

          const values = [];
          for (const d of discounts) {
            values.push([
              {
                border: [false, false, false, true],
                bold: true,
                text: d.toUpperCase(),
              },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
            ]);

            const filteredEmployees = data.filter((e) =>
              e.discountsList
                .map((l) => l.personalAction.name.trim())
                .includes(d)
            );

            const subtotal = 0;
            for (const e of filteredEmployees) {
              for (const d of e.discountsList.filter(
                (l) => l.personalAction.name.trim() == d
              )) {
                const amount = d.value * -1;
                subtotal += amount;
                values.push([
                  { text: "" },
                  { text: e.code },
                  { text: e.priorDepartment },
                  { text: e.priorCostCenter },
                  { text: formatName(e.employee) },
                  {
                    alignment: "right",
                    text: formatMoney(amount),
                  },
                ]);
              }
            }
            values.push([
              { text: "" },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                alignment: "right",
                bold: true,
                text: formatMoney(subtotal),
                border: [false, true, false, false],
              },
            ]);
          }
          values.push([
            "",
            "",
            "",
            "",
            {
              bold: true,
              text: "TOTAL:",
              alignment: "right",
              border: [false, false, false, true],
              fontSize: 10,
              margin: [0, 30, 0, 0],
            },
            {
              bold: true,
              text: formatMoney(data.reduce((a, b) => a + b.discounts, 0)),
              alignment: "right",
              border: [false, false, false, true],
              fontSize: 10,
              margin: [0, 30, 0, 0],
            },
          ]);
          values.push([
            "",
            "",
            "",
            "",
            "",
            {
              text: "",
              margin: [0, 0, 0, 50],
            },
          ]);
          const docDefinition = {
            pageSize: "LETTER",
            pageOrientation: "portrait",
            pageMargins: [20, 80, 20, 40],
            header: getHeader(
              "CALDER, SOCIEDAD ANÓNIMA",
              [paysheet.startDate, paysheet.endDate],
              `PLANILLA No. ${paysheet.code}`,
              "fixed",
              `REPORTE DE DESCUENTOS`
            ),
            footer: getFooter(),
            content: [
              {
                style: "tableStyle",
                layout: {
                  defaultBorder: false,
                },
                table: {
                  headerRows: 1,
                  widths: [100, 35, 100, 100, "*", 60],
                  body: [
                    [
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "CODIGO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "DEPARTAMENTO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "CENTRO DE COSTO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "NOMBRE",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "VALOR",
                        bold: true,
                        alignment: "right",
                      },
                    ],
                    ...values,
                    [
                      {
                        colSpan: 6,
                        layout: {
                          defaultBorder: false,
                        },
                        table: {
                          widths: [20, "*", 20, "*", 20, "*", 20],
                          body: [
                            [
                              "",
                              {
                                text: "ELABORADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "REVISADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "AUTORIZADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                            ],
                          ],
                        },
                      },
                    ],
                  ],
                },
              },
            ],
            styles: {
              tableStyle: {
                fontSize: 8.5,
              },
            },
          };
          pdfMake.createPdf(docDefinition).open();
          break;

        case "excel":
          const filename = `descuentos-${paysheet.code}-${format(
            new Date(),
            "YYYYMMDDHHmmss"
          )}`;
          const excelValues = [];

          for (const d of data) {
            for (const a of d.discountsList) {
              excelValues.push({
                Planilla: paysheet.code,
                Quincena: paysheet.sequence,
                Codigo: d.code,
                NombreCompleto: formatName(d.employee),
                Departamento: d.priorDepartment,
                CentroDeCosto: d.priorCostCenter,
                NombreAccion: a.personalAction.name.trim(),
                CantidadAccion: a.value,
              });
            }
          }
          const worksheet = XLSX.utils.json_to_sheet(excelValues);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, worksheet, "Descuentos");
          XLSX.writeFile(wb, `${filename}.xlsx`);
          break;
      }
    },

    // PARA GRATIFICACIONS
    async openForGratifications() {
      await this.fetchPaysheets();
      this.showGratificationDialog = true;
    },
    gratificationsPaysheetChange(selectedPaysheet) {
      this.gratificationsDataLoading = true;
      axios
        .post("/", {
          query: `{
            paysheetHistory(where:{ paysheet: ${selectedPaysheet} }) {
              id
              fullName
              workedDays
              missedDays
              salary
              salaryForPayroll
              overtime
              gratification
              discounts
              subtotalSalary
              taxes
              socialEmployee
              afpEmployee
              socialEmployer
              afpEmployer
              total
              code
              priorDepartment
              priorCostCenter
              employee {
                name1, name2, name3, lastname1, lastname2, lastname3
              }
            }
            personalActionHistory(where:{ paysheet: ${selectedPaysheet} }) {
              name
              value
              amount
              personalAction { id name baseSalary termination discount }
              employee { code }
              PAdeductISR
              type
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          this.gratificationsData = data.paysheetHistory.map((h) => {
            const personalActions = data.personalActionHistory.filter(
                (pa) => pa.employee.code == h.code
              ),
              index = index + 1;
            return {
              index: index.toString(),
              ...h,
              workedDays: h.workedDays.toString(),
              gratificationsList: personalActions.filter((pa) => {
                return (
                  pa.value > 0 &&
                  !pa.personalAction.baseSalary &&
                  !pa.personalAction.termination &&
                  !pa.personalAction.discount
                );
              }),
              discountsList: personalActions.filter((pa) => pa.type == 3),
            };
          });
          this.gratificationsDataDepartments = [
            ...new Set(data.paysheetHistory.map((ph) => ph.priorDepartment)),
          ].filter((e) => e != "null");
          this.gratificationsDataEmployees = data.paysheetHistory.map((ph) => ({
            id: ph.id,
            fullname: ph.fullName.split("  ").join(" "),
          }));
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(err.message);
        })
        .then((alw) => {
          this.gratificationsDataLoading = false;
        });
    },
    generateGratificationReport(options) {
      const paysheet = this.paysheets.find(
        (p) => p.id == options.selectedPaysheet
      );

      let data = [];
      switch (options.type) {
        case 1: // Todos
          data = this.gratificationsData;
          break;
        case 2: // x Departamento
          data = this.gratificationsData.filter((d) =>
            options.selection.includes(d.priorDepartment)
          );
          break;
        case 3: // x Empleado
          data = this.gratificationsData.filter((d) => {
            return options.selection.includes(d.id);
          });
          break;
      }

      switch (options.export) {
        case "pdf":
          //  obtiene el listado de descuentos
          let gratifications = [];
          for (const d of data) {
            gratifications = gratifications.concat(
              d.gratificationsList.map((dl) => dl.name.trim())
            );
          }

          gratifications = [...new Set(gratifications)];

          const values = [];
          let total = 0;
          for (const d of gratifications) {
            values.push([
              {
                border: [false, false, false, true],
                bold: true,
                text: d.toUpperCase(),
              },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
            ]);

            const filteredEmployees = data.filter((e) =>
              e.gratificationsList
                .map((l) => l.personalAction.name.trim())
                .includes(d)
            );
            const subtotal = 0;

            for (const e of filteredEmployees) {
              for (const g of e.gratificationsList.filter(
                (l) => l.personalAction.name.trim() == d
              )) {
                subtotal += g.value;
                values.push([
                  { text: "" },
                  { text: e.code },
                  { text: e.priorDepartment },
                  { text: e.priorCostCenter },
                  { text: formatName(e.employee) },
                  {
                    alignment: "right",
                    text: formatMoney(g.value),
                  },
                ]);
              }
            }

            values.push([
              { text: "" },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                alignment: "right",
                bold: true,
                text: formatMoney(subtotal),
                border: [false, true, false, false],
              },
            ]);
            total += subtotal;
          }
          values.push([
            "",
            "",
            "",
            "",
            {
              bold: true,
              text: "TOTAL:",
              alignment: "right",
              border: [false, false, false, true],
              fontSize: 10,
              margin: [0, 30, 0, 0],
            },
            {
              bold: true,
              text: formatMoney(total),
              alignment: "right",
              border: [false, false, false, true],
              fontSize: 10,
              margin: [0, 30, 0, 0],
            },
          ]);
          values.push([
            "",
            "",
            "",
            "",
            "",
            {
              text: "",
              margin: [0, 0, 0, 50],
            },
          ]);
          const docDefinition = {
            pageSize: "LETTER",
            pageOrientation: "portrait",
            pageMargins: [20, 80, 20, 40],
            header: getHeader(
              "CALDER, SOCIEDAD ANÓNIMA",
              [paysheet.startDate, paysheet.endDate],
              `PLANILLA No. ${paysheet.code}`,
              "fixed",
              `REPORTE DE GRATIFICATIONES`
            ),
            footer: getFooter(),
            content: [
              {
                style: "tableStyle",
                layout: {
                  defaultBorder: false,
                },
                table: {
                  headerRows: 1,
                  widths: [100, 35, 100, 100, "*", 60],
                  body: [
                    [
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "CODIGO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "DEPARTAMENTO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "CENTRO DE COSTO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "NOMBRE",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "VALOR",
                        bold: true,
                      },
                    ],
                    ...values,
                    [
                      {
                        colSpan: 6,
                        layout: {
                          defaultBorder: false,
                        },
                        table: {
                          widths: [20, "*", 20, "*", 20, "*", 20],
                          body: [
                            [
                              "",
                              {
                                text: "ELABORADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "REVISADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "AUTORIZADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                            ],
                          ],
                        },
                      },
                    ],
                  ],
                },
              },
            ],
            styles: {
              tableStyle: {
                fontSize: 8.5,
              },
            },
          };
          pdfMake.createPdf(docDefinition).open();
          break;

        case "excel":
          const filename = `gratificaciones-${paysheet.code}-${format(
            new Date(),
            "YYYYMMDDHHmmss"
          )}`;
          const excelValues = [];
          for (const d of data) {
            for (const a of d.gratificationsList) {
              excelValues.push({
                Planilla: paysheet.code,
                Quincena: paysheet.sequence,
                Codigo: d.code,
                NombreCompleto: formatName(d.employee),
                Departamento: d.priorDepartment,
                CentroDeCosto: d.priorCostCenter,
                NombreAccion: a.personalAction.name.trim(),
                CantidadAccion: a.value,
              });
            }
          }
          const worksheet = XLSX.utils.json_to_sheet(excelValues);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, worksheet, "Gratificaciones");
          XLSX.writeFile(wb, `${filename}.xlsx`);
          break;
      }
    },

    // PARA HORAS EXTRA
    async openForOvertime() {
      await this.fetchPaysheets();
      this.showOvertimeDialog = true;
    },
    overtimePaysheetChange(selectedPaysheet) {
      this.overtimeDataLoading = true;
      axios
        .post("/", {
          query: `{
            paysheetHistory(where:{ paysheet: ${selectedPaysheet} }) {
              id
              fullName
              workedDays
              missedDays
              salary
              salaryForPayroll
              overtime
              gratification
              discounts
              subtotalSalary
              taxes
              socialEmployee
              afpEmployee
              socialEmployer
              afpEmployer
              total
              code
              priorDepartment
              priorCostCenter
              employee { 
                name1, name2, name3, lastname1, lastname2, lastname3
                userActions { email } 
              }
            }
            overtimeHistory(where:{ paysheet: ${selectedPaysheet} }) {
              hours
              factor
              name
              date
              comment
              employee { code }
              value
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          this.overtimeData = data.paysheetHistory.map((h) => {
            return {
              ...h,
              workedDays: h.workedDays.toString(),
              overtimeList: data.overtimeHistory.filter(
                (o) => o.employee.code == h.code
              ),
            };
          });
          this.overtimeDataDepartments = [
            ...new Set(data.paysheetHistory.map((ph) => ph.priorDepartment)),
          ].filter((e) => e != "null");
          this.overtimeDataEmployees = data.paysheetHistory.map((ph) => ({
            id: ph.id,
            fullname: ph.fullName.split("  ").join(" "),
          }));
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(err.message);
        })
        .then((alw) => {
          this.overtimeDataLoading = false;
        });
    },
    generateOvertimeReport(options) {
      const paysheet = this.paysheets.find(
        (p) => p.id == options.selectedPaysheet
      );
      let data = [];
      switch (options.type) {
        case 1: // Todos
          data = this.overtimeData;
          break;
        case 2: // x Departamento
          data = this.overtimeData.filter((d) =>
            options.selection.includes(d.priorDepartment)
          );
          break;
        case 3: // x Empleado
          data = this.overtimeData.filter((d) => {
            return options.selection.includes(d.id);
          });
          break;
      }

      switch (options.export) {
        case "pdf":
          //  obtiene el listado de descuentos
          let overtime = [];
          for (const d of data) {
            overtime = overtime.concat(
              d.overtimeList.map((dl) => dl.name.trim())
            );
          }

          overtime = [...new Set(overtime)];

          const values = [];
          let total = 0;
          for (const d of overtime) {
            values.push([
              {
                border: [false, false, false, true],
                bold: true,
                text: d.toUpperCase(),
              },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
              { border: [false, false, false, true], text: "" },
            ]);
            const filteredEmployees = data.filter((e) => {
              return e.overtimeList.map((l) => l.name.trim()).includes(d);
            });
            const subtotal = 0;
            for (const e of filteredEmployees) {
              const amount = e.overtimeList
                .filter(
                  (o) => o.name.trim().toLowerCase() == d.trim().toLowerCase()
                )
                .reduce((a, b) => a + b.value, 0);
              subtotal += amount;
              values.push([
                { text: "" },
                { text: e.code },
                { text: e.priorDepartment },
                { text: e.priorCostCenter },
                { text: formatName(e.employee) },
                {
                  alignment: "right",
                  text: formatMoney(amount),
                },
              ]);
            }
            values.push([
              { text: "" },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                alignment: "right",
                bold: true,
                text: formatMoney(subtotal),
                border: [false, true, false, false],
              },
            ]);
            total += subtotal;
          }
          values.push([
            "",
            "",
            "",
            "",
            {
              bold: true,
              text: "TOTAL:",
              alignment: "right",
              border: [false, false, false, true],
              fontSize: 10,
              margin: [0, 30, 0, 0],
            },
            {
              bold: true,
              text: formatMoney(total),
              alignment: "right",
              border: [false, false, false, true],
              fontSize: 10,
              margin: [0, 30, 0, 0],
            },
          ]);
          values.push([
            "",
            "",
            "",
            "",
            "",
            {
              text: "",
              margin: [0, 0, 0, 50],
            },
          ]);
          const docDefinition = {
            pageSize: "LETTER",
            pageOrientation: "portrait",
            pageMargins: [20, 80, 20, 40],
            header: getHeader(
              "CALDER, SOCIEDAD ANÓNIMA",
              [paysheet.startDate, paysheet.endDate],
              `PLANILLA No. ${paysheet.code}`,
              "fixed",
              `REPORTE DE GRATIFICATIONES`
            ),
            footer: getFooter(),
            content: [
              {
                style: "tableStyle",
                layout: {
                  defaultBorder: false,
                },
                table: {
                  headerRows: 1,
                  widths: [100, 35, 100, 100, "*", 60],
                  body: [
                    [
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "CODIGO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "DEPARTAMENTO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "CENTRO DE COSTO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "NOMBRE",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "VALOR",
                        bold: true,
                      },
                    ],
                    ...values,
                    [
                      {
                        colSpan: 6,
                        layout: {
                          defaultBorder: false,
                        },
                        table: {
                          widths: [20, "*", 20, "*", 20, "*", 20],
                          body: [
                            [
                              "",
                              {
                                text: "ELABORADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "REVISADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "AUTORIZADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                            ],
                          ],
                        },
                      },
                    ],
                  ],
                },
              },
            ],
            styles: {
              tableStyle: {
                fontSize: 8.5,
              },
            },
          };
          pdfMake.createPdf(docDefinition).open();
          break;

        case "excel":
          const filename = `horas-extra-${paysheet.code}-${format(
            new Date(),
            "YYYYMMDDHHmmss"
          )}`;
          const excelValues = [];
          for (const d of data) {
            for (const a of d.overtimeList) {
              excelValues.push({
                ID: d.code,
                DEPARTAMENTO: d.priorDepartment,
                CENTROCOSTO: d.priorCostCenter,
                NOMBRE: formatName(d.employee),
                SALARIO: parseFloat((d.salary  * 12 / 365 / 8).toFixed(3)),
                HEXTRA: a.hours,
                TIPO: a.factor,
                CTIPO: a.name.trim(),
                VALOR: parseFloat(a.value.toFixed(2)),
                DESCRIPCION: d.priorDepartment,
                FECHA_LABO: a.date,
                USUARIO: d.employee.userActions.email,
                PLANILLA: paysheet.code,
                QUINCENA: paysheet.sequence,
                FECHAINI: paysheet.startDate,
                FECHAFIN: paysheet.endDate,
                ANIO: paysheet.year,
                MES: paysheet.month,
                NOTAS: a.comment,
              });
            }
          }
          const worksheet = XLSX.utils.json_to_sheet(excelValues);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, worksheet, "Horas Extra");
          XLSX.writeFile(wb, `${filename}.xlsx`);
          break;
      }
    },

    // PARA RESUMEN DE PLANILLA
    async openForResumenDePlanilla() {
      await this.fetchPaysheets();
      this.showResumenDePlanillaDialog = true;
    },
    generateResumenDePlanillaReport(options) {
      this.resumenPlanillaDataLoading = true;
      axios
        .post("/", {
          query: `{
            personalActionHistory(where:{paysheet:${options.selectedPaysheet}, type:2}){
              name
              value
              amount
              type
              employee{
                code
                name1
                name2
                name3
                lastname1
                lastname2
                lastname3
              }
            }

              paysheetHistory(where:{paysheet:${options.selectedPaysheet}}){
                id
                fullName
                workedDays
                missedDays
                salary
                salaryForPayroll
                overtime
                gratification
                discounts
                subtotalSalary
                taxes
                socialEmployee
                socialEmployer
                afpEmployee
                afpEmployer
                total
                code
                priorDepartment
                priorCostCenter

              }



              paysheetHistoryFilter(where:{paysheet:${options.selectedPaysheet}}){
                paysheetId
                priorDepartment
                salaryforpayroll
                overtime
                taxes
                socialemployer
                afpemployer
                discounts
                socialemployee
                afpemployee
                total
                name
                valor
                id
              }


          }`,
        })
        .then((res) => {
          //**************************************************/
          //**************************************************/
          let paysheetHistoryFilter = res.data.data.paysheetHistoryFilter;
          let info = paysheetHistoryFilter.reduce(
            (a, { name, valor, ...n }) => {
              let temp = a.find(
                (o) => o.priorDepartment.trim() == n.priorDepartment.trim()
              );
              if (!temp) {
                if (name) {
                  n.cl = [{ name: name ? name.trim() : name, valor }];
                } else {
                  n.cl = [];
                }
                a.push(n);
              } else {
                temp.cl.push({ name: name ? name.trim() : name, valor });
              }
              return a;
            },
            []
          );

          const content = [];
          const noBorder = { border: [false, false, false, false] };
          const upBorder = { border: [false, true, false, false] };
          const downBorder = { border: [false, false, false, true] };
          let contador = 1;
          let totalGrat = {};

          let fsalaryforpayroll = 0;
          let fovertime = 0;
          let ftaxes = 0;
          let fsocialemployee = 0;
          let fafpemployee = 0;
          let fdiscounts = 0;
          let ftdescuento = 0;
          let fsocialemployer = 0;
          let fafpemployer = 0;
          let ftingresos = 0;

          for (const g of info) {
            let tingresos = g.salaryforpayroll + g.overtime;
            let tdescuento =
              g.taxes + g.socialemployee + g.afpemployee + g.discounts * -1;

            //******************************* Asignación de variables para resumen final **************************************** */
            fsalaryforpayroll += g.salaryforpayroll;
            fovertime += g.overtime;
            ftingresos += tingresos;
            ftaxes += g.taxes;
            fsocialemployee += g.socialemployee;
            fafpemployee += g.afpemployee;
            fdiscounts += g.discounts;
            ftdescuento += tdescuento;
            fsocialemployer += g.socialemployer;
            fafpemployer += g.afpemployer;

            //****************************Fin Asignación de variables para resumen final **************************************** */

            let grat = [
              [
                { text: "", fontSize: 8, bold: true, ...noBorder },
                { text: "", fontSize: 8, bold: true, ...noBorder },
              ],
            ];

            if (g.cl.length > 0) {
              grat = [];
              for (const u of g.cl) {
                if (!totalGrat[u.name]) {
                  totalGrat[u.name] = 0;
                }
                totalGrat[u.name] += u.valor;

                tingresos += u.valor;
                grat.push([
                  { text: u.name, fontSize: 8, bold: true, ...noBorder },
                  {
                    text: formatMoney(u.valor),
                    fontSize: 8,
                    alignment: "right",
                    bold: true,
                    ...noBorder,
                  },
                ]);
              }
            }

            content.push({
              style: "sinBorde",
              layout: "",
              table: {
                headerRows: 1,
                widths: ["*", 150, "*", "*", "*", "*"],
                body: [
                  [
                    { text: "TOTAL", fontSize: 9, bold: true, ...downBorder },
                    {
                      text: g.priorDepartment,
                      fontSize: 9,
                      alignment: "right",
                      bold: true,
                      ...downBorder,
                    },
                    { text: "", fontSize: 9, bold: true, ...downBorder },
                    { text: "", fontSize: 9, bold: true, ...downBorder },
                    { text: "", fontSize: 9, bold: true, ...downBorder },
                    { text: "", fontSize: 9, bold: true, ...downBorder },
                  ],
                  [
                    {
                      stack: [
                        {
                          table: {
                            widths: [95, "*"],
                            body: [
                              [
                                {
                                  text: "SUELDO PERIODO",
                                  fontSize: 8,
                                  ...noBorder,
                                },
                                {
                                  text: formatMoney(g.salaryforpayroll),
                                  fontSize: 8,
                                  alignment: "right",
                                  ...noBorder,
                                },
                              ],
                              ...grat,
                              [
                                {
                                  text: "HORAS EXTRAS",
                                  fontSize: 8,
                                  ...noBorder,
                                },
                                {
                                  text: formatMoney(g.overtime),
                                  fontSize: 8,
                                  alignment: "right",
                                  ...noBorder,
                                },
                              ],
                            ],
                          },
                        },
                      ],
                      colSpan: 2,
                      fontSize: 9,
                      bold: true,
                      ...noBorder,
                    },
                    {},
                    {
                      stack: [
                        {
                          table: {
                            widths: [95, "*"],
                            body: [
                              [
                                {
                                  text: "RETENCION RENTA",
                                  fontSize: 8,
                                  ...noBorder,
                                },
                                {
                                  text: formatMoney(g.taxes),
                                  fontSize: 8,
                                  alignment: "right",
                                  ...noBorder,
                                },
                              ],
                              [
                                { text: "IGSS", fontSize: 8, ...noBorder },
                                {
                                  text: formatMoney(g.socialemployee),
                                  fontSize: 8,
                                  alignment: "right",
                                  ...noBorder,
                                },
                              ],
                              [
                                {
                                  text: "OTROS DESCUENTOS",
                                  fontSize: 8,
                                  ...noBorder,
                                },
                                {
                                  text: formatMoney(g.discounts * -1),
                                  fontSize: 8,
                                  alignment: "right",
                                  ...noBorder,
                                },
                              ],
                              [
                                {
                                  text: "TOTAL DESCUENTOS",
                                  fontSize: 8,
                                  ...noBorder,
                                },
                                {
                                  text: formatMoney(tdescuento),
                                  fontSize: 8,
                                  alignment: "right",
                                  ...upBorder,
                                },
                              ],
                              [
                                {
                                  text: "",
                                  fontSize: 9,
                                  bold: true,
                                  ...noBorder,
                                },
                                {
                                  text: "",
                                  fontSize: 9,
                                  bold: true,
                                  ...noBorder,
                                },
                              ],
                              [
                                {
                                  text: "IGSS PATRONAL",
                                  fontSize: 8,
                                  ...noBorder,
                                },

                                {
                                  text: formatMoney(g.socialemployer),
                                  fontSize: 8,
                                  alignment: "right",
                                  ...downBorder,
                                },
                              ],
                              [
                                {
                                  text: "TOTAL PATRONAL",
                                  fontSize: 8,
                                  ...noBorder,
                                },
                                {
                                  text: formatMoney(
                                    g.socialemployer
                                  ),
                                  alignment: "right",
                                  fontSize: 8,
                                  ...noBorder,
                                },
                              ],
                              [
                                { text: "", fontSize: 8, ...noBorder },
                                { text: "", fontSize: 8, ...noBorder },
                              ],
                            ],
                          },
                        },
                      ],
                      colSpan: 2,
                      fontSize: 9,
                      bold: true,
                      ...noBorder,
                    },
                    {},
                    { text: "", fontSize: 9, bold: true, ...noBorder },
                    { text: "", fontSize: 9, bold: true, ...noBorder },
                  ],
                  [
                    { text: "TOTAL INGRESOS", fontSize: 8, ...noBorder },
                    {
                      text: formatMoney(tingresos),
                      fontSize: 8,
                      ...upBorder,
                      alignment: "right",
                    },
                    { text: "PAGO NETO", fontSize: 8, ...noBorder },
                    {
                      text: formatMoney(tingresos - tdescuento),
                      colSpan: 2,
                      fontSize: 8,
                      alignment: "right",
                      ...upBorder,
                    },
                    { text: "", fontSize: 8, ...noBorder },
                    { text: "", fontSize: 8, ...noBorder },
                  ],
                  [
                    { text: "", fontSize: 8, ...noBorder, margin: [0, 20] },
                    { text: "", fontSize: 8, ...noBorder },
                    { text: "", fontSize: 8, ...noBorder },
                    { text: "", fontSize: 8, ...noBorder },
                    { text: "", fontSize: 8, ...noBorder },
                    { text: "", fontSize: 8, ...noBorder },
                  ],
                ],
              },
            });

            if (contador % 3 == 0 && info.length != contador) {
              content.push({ text: "", pageBreak: "before" });
            }
            contador++;
          }

          //sacar total de bonos y grats
          let ngrat = [];
          let tgrat = 0;

          Object.keys(totalGrat).forEach(function(v, i) {
            tgrat += totalGrat[v];
            ngrat.push([
              { text: v, fontSize: 8, bold: true, ...noBorder },
              {
                text: formatMoney(totalGrat[v]),
                fontSize: 8,
                alignment: "right",
                bold: true,
                ...noBorder,
              },
            ]);
          });

          //*********************************************************************************** */
          content.push({ text: "", pageBreak: "before" });
          content.push({
            style: "sinBorde",
            layout: "",
            table: {
              headerRows: 1,
              widths: ["*", 150, "*", "*", "*", "*"],
              body: [
                [
                  { text: "TOTAL", fontSize: 9, bold: true, ...downBorder },
                  {
                    text: "********* RESUMEN TOTAL *********",
                    fontSize: 9,
                    alignment: "right",
                    bold: true,
                    ...downBorder,
                  },
                  { text: "", fontSize: 9, bold: true, ...downBorder },
                  { text: "", fontSize: 9, bold: true, ...downBorder },
                  { text: "", fontSize: 9, bold: true, ...downBorder },
                  { text: "", fontSize: 9, bold: true, ...downBorder },
                ],
                [
                  {
                    stack: [
                      {
                        table: {
                          widths: [95, "*"],
                          body: [
                            [
                              {
                                text: "SUELDO PERIODO",
                                fontSize: 8,
                                ...noBorder,
                              },
                              {
                                text: formatMoney(fsalaryforpayroll),
                                fontSize: 8,
                                alignment: "right",
                                ...noBorder,
                              },
                            ],
                            ...ngrat,
                            [
                              {
                                text: "HORAS EXTRAS",
                                fontSize: 8,
                                ...noBorder,
                              },
                              {
                                text: formatMoney(fovertime),
                                fontSize: 8,
                                alignment: "right",
                                ...noBorder,
                              },
                            ],
                          ],
                        },
                      },
                    ],
                    colSpan: 2,
                    fontSize: 9,
                    bold: true,
                    ...noBorder,
                  },
                  {},
                  {
                    stack: [
                      {
                        table: {
                          widths: [95, "*"],
                          body: [
                            [
                              {
                                text: "RETENCION RENTA",
                                fontSize: 8,
                                ...noBorder,
                              },
                              {
                                text: formatMoney(ftaxes),
                                fontSize: 8,
                                alignment: "right",
                                ...noBorder,
                              },
                            ],
                            [
                              { text: "IGSS", fontSize: 8, ...noBorder },
                              {
                                text: formatMoney(fsocialemployee),
                                fontSize: 8,
                                alignment: "right",
                                ...noBorder,
                              },
                            ],
                            [
                              {
                                text: "OTROS DESCUENTOS",
                                fontSize: 8,
                                ...noBorder,
                              },
                              {
                                text: formatMoney(fdiscounts * -1),
                                fontSize: 8,
                                alignment: "right",
                                ...noBorder,
                              },
                            ],
                            [
                              {
                                text: "TOTAL DESCUENTOS",
                                fontSize: 8,
                                ...noBorder,
                              },
                              {
                                text: formatMoney(ftdescuento),
                                fontSize: 8,
                                alignment: "right",
                                ...upBorder,
                              },
                            ],
                            [
                              {
                                text: "",
                                fontSize: 9,
                                bold: true,
                                ...noBorder,
                              },
                              {
                                text: "",
                                fontSize: 9,
                                bold: true,
                                ...noBorder,
                              },
                            ],
                            [
                              {
                                text: "IGSS PATRONAL",
                                fontSize: 8,
                                ...noBorder,
                              },

                              {
                                text: formatMoney(fsocialemployer),
                                fontSize: 8,
                                alignment: "right",
                                ...downBorder,
                              },
                            ],
                            [
                              {
                                text: "TOTAL PATRONAL",
                                fontSize: 8,
                                ...noBorder,
                              },
                              {
                                text: formatMoney(
                                  fsocialemployer
                                ),
                                alignment: "right",
                                fontSize: 8,
                                ...noBorder,
                              },
                            ],
                            [
                              { text: "", fontSize: 8, ...noBorder },
                              { text: "", fontSize: 8, ...noBorder },
                            ],
                          ],
                        },
                      },
                    ],
                    colSpan: 2,
                    fontSize: 9,
                    bold: true,
                    ...noBorder,
                  },
                  {},
                  { text: "", fontSize: 9, bold: true, ...noBorder },
                  { text: "", fontSize: 9, bold: true, ...noBorder },
                ],
                [
                  { text: "TOTAL INGRESOS", fontSize: 8, ...noBorder },
                  {
                    text: formatMoney(tgrat + fsalaryforpayroll + fovertime),
                    fontSize: 8,
                    ...upBorder,
                    alignment: "right",
                  },
                  { text: "PAGO NETO", fontSize: 8, ...noBorder },
                  {
                    text: formatMoney(
                      tgrat + fsalaryforpayroll + fovertime - ftdescuento
                    ),
                    colSpan: 2,
                    fontSize: 8,
                    alignment: "right",
                    ...upBorder,
                  },
                  { text: "", fontSize: 8, ...noBorder },
                  { text: "", fontSize: 8, ...noBorder },
                ],
                [
                  { text: "", fontSize: 8, ...noBorder, margin: [0, 20] },
                  { text: "", fontSize: 8, ...noBorder },
                  { text: "", fontSize: 8, ...noBorder },
                  { text: "", fontSize: 8, ...noBorder },
                  { text: "", fontSize: 8, ...noBorder },
                  { text: "", fontSize: 8, ...noBorder },
                ],
              ],
            },
          });

          //*********************************************************************************** */

          content.push({
            alignment: "center",
            margin: [0, 0, 0, 0],
            columns: [
              {
                text: "____________________________________\nELABORADO",
                fontSize: 9,
              },
              {
                text: "____________________________________\nREVISADO",
                fontSize: 9,
              },
              {
                text: "____________________________________\nAUTORIZADO",
                fontSize: 9,
              },
            ],
          });
          const paysheet = this.paysheets.find(
            (p) => p.id == options.selectedPaysheet
          );

          let dd = {
            pageSize: "LETTER",
            pageOrientation: "portrait",
            pageMargins: [20, 80, 20, 40],
            header: getHeader(
              "CALDER, SOCIEDAD ANÓNIMA",
              [paysheet.startDate, paysheet.endDate],
              `PLANILLA No. ${paysheet.code}`,
              "fixed",
              `RESUMEN DE PLANILLA`
            ),
            footer: getFooter(),
            content,
            styles: { sinBorde: { border: [false, false, false, false] } },
          };
          pdfMake.createPdf(dd).open();
          this.resumenPlanillaDataLoading = false;
          return;

          //**************************************************/
          //**************************************************/
        })
        .catch((err) => {
          console.error(err);
        });
      return;
    },

    // PARA PAGOS ELECTRONICOS
    async openForPagoElectronico() {
      await this.fetchPaysheets();
      this.showPagoElectronicoDialog = true;
    },
    pagoElectronicoPaysheetChange(selectedPaysheet) {
      this.pagoElectronicoDataLoading = true;
      axios
        .post("/", {
          query: `{
            paysheetHistory(where:{ paysheet: ${selectedPaysheet} }) {
              id
              employee { id code name1 name2 name3 lastname1 lastname2 lastname3 bankAccount }
              total
              priorDepartment
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          this.pagoElectronicoData = data.paysheetHistory.map((h) => {
            const bankAccount = h.employee.bankAccount ? h.employee.bankAccount.split("") : [];
            if (bankAccount.length > 0) {
              bankAccount.splice(4, 0, "");
              bankAccount.splice(-1, 0, "");
            }
            return {
              ...h,
              names: `${h.employee.name1 ? h.employee.name1 + " " : ""}${
                h.employee.name2 ? h.employee.name2 + " " : ""
              }${h.employee.name3 ? h.employee.name3 + " " : ""}`.trim(),
              lastnames: `${
                h.employee.lastname1 ? h.employee.lastname1 + " " : ""
              }${h.employee.lastname2 ? h.employee.lastname2 + " " : ""}${
                h.employee.lastname3 ? h.employee.lastname3 + " " : ""
              }`.trim(),
              bankAccount: bankAccount.length > 0 ? bankAccount.join("") : "sin dato",
              code: h.employee.code,
            };
          });
          this.pagoElectronicoDataDepartments = [
            ...new Set(data.paysheetHistory.map((ph) => ph.priorDepartment)),
          ].filter((e) => e != "null");
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(err.message);
        })
        .then((alw) => {
          this.pagoElectronicoDataLoading = false;
        });
    },
    generatePagoElectronicoReport(options) {
      const paysheet = this.paysheets.find(
        (p) => p.id == options.selectedPaysheet
      );

      let data = [];
      switch (options.type) {
        case 1: // Todos
          data = this.pagoElectronicoData;
          break;
        case 2: // x Departamento
          data = this.pagoElectronicoData.filter((d) =>
            options.selection.includes(d.priorDepartment)
          );
          break;
      }

      switch (options.export) {
        case "pdf":
          const docDefinition = {
            pageSize: "LETTER",
            pageOrientation: "portrait",
            pageMargins: [20, 80, 20, 40],
            header: getHeader(
              "CALDER, SOCIEDAD ANÓNIMA",
              [paysheet.startDate, paysheet.endDate],
              `PLANILLA No. ${paysheet.code}`,
              "fixed",
              `LISTADO DE REVISION DE DEPOSITOS A CUENTAS DE EMPLEADOS`
            ),
            footer: getFooter(),
            content: [
              {
                style: "tableStyle",
                layout: {
                  defaultBorder: false,
                },
                table: {
                  headerRows: 1,
                  widths: [30, 40, "*", 100, 70],
                  body: [
                    [
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "N°",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "CODIGO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "NOMBRE",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "CUENTA",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 9,
                        text: "VALOR",
                        bold: true,
                        alignment: "right",
                      },
                    ],
                    ...data.map((d, i) => {
                      return [
                        { text: i + 1 },
                        { text: d.code },
                        { text: `${d.names}, ${d.lastnames}` },
                        { text: d.bankAccount },
                        { text: formatMoney(d.total), alignment: "right" },
                      ];
                    }),
                    [
                      "",
                      "",
                      "",
                      {
                        text: "TOTAL",
                        bold: true,
                        fontSize: 10,
                        margin: [0, 15, 0, 0],
                        border: [false, false, false, true],
                      },
                      {
                        text: formatMoney(
                          data.reduce((a, b) => a + b.total, 0)
                        ),
                        bold: true,
                        fontSize: 10,
                        alignment: "right",
                        margin: [0, 15, 0, 0],
                        border: [false, false, false, true],
                      },
                    ],
                    [
                      {
                        margin: [0, 60, 0, 0],
                        colSpan: 5,
                        layout: {
                          defaultBorder: false,
                        },
                        table: {
                          widths: [20, "*", 20, "*", 20, "*", 20],
                          body: [
                            [
                              "",
                              {
                                text: "ELABORADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "REVISADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "AUTORIZADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                            ],
                          ],
                        },
                      },
                    ],
                  ],
                },
              },
            ],
            styles: {
              tableStyle: {
                fontSize: 8.5,
              },
            },
          };
          pdfMake.createPdf(docDefinition).open();
          break;

        case "excel":
          const filename = `pago-electronico-${paysheet.code}-${format(
            new Date(),
            "YYYYMMDDHHmmss"
          )}`;

          

          const string = data
            .map(
              (d, i) =>
                `1,${d.bankAccount !== 'sin dato' ? d.bankAccount.padStart(10, '0') : d.bankAccount},${d.names} ${
                  d.lastnames
                },${d.total.toFixed(2)},Pago de Salario Quincenal                 \n`
            )
            .join("");
          var blob = new Blob(
            [
              `\uFEFF\n${string}1,05410033709,CALDER, SOCIEDAD ANÓNIMA,${data
                .reduce((a, b) => a + b.total, 0)
                .toFixed(2)},Pago de Salario Quincenal               `,
            ],
            {
              type: "text/csv;charset=utf-8",
            }
          );
          saveAs(blob, `${filename}.csv`);
          break;
      }
    },

    // PARA PLANILLA GENERAL
    async openForPlanillaGeneral() {
      await this.fetchPaysheets();
      this.showPlanillaGeneralDialog = true;
    },
    planillaGeneralPaysheetChange(selectedPaysheet) {
      this.planillaGeneralDataLoading = true;
      axios
        .post("/", {
          query: `{
            paysheetHistory(where:{ paysheet: ${selectedPaysheet} }) {
              id
              fullName
              workedDays
              missedDays
              salary
              salaryForPayroll
              overtime
              gratification
              discounts
              subtotalSalary
              taxes
              socialEmployee
              afpEmployee
              socialEmployer
              afpEmployer
              total
              code
              priorDepartment
              employee {
                name1, name2, name3, lastname1, lastname2, lastname3
                oldCostCenter { name }
                documents { number documentType { shortName } }
              }
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          this.planillaGeneralData = data.paysheetHistory.map((h, index) => {
            index = index + 1;
            return {
              index: index.toString(),
              ...h,
              workedDays: h.workedDays.toString(),
            };
          });
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(err.message);
        })
        .then((alw) => {
          this.planillaGeneralDataLoading = false;
        });
    },
    generatePlanillaGeneralReport(options) {
      const paysheet = this.paysheets.find(
        (p) => p.id == options.selectedPaysheet
      );

      let data = [];
      switch (options.type) {
        case "ordinaria": // general
          data = this.planillaGeneralData;
          break;
      }

      switch (options.export) {
        case "pdf":
          const departments = [...new Set(data.map((d) => d.priorDepartment))];

          const values = [];
          for (const d of departments) {
            values.push([
              {
                colSpan: 2,
                text: d,
                bold: true,
                margin: [0, 10, 0, 0],
                border: [false, false, false, true],
              },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
              { text: "", border: [false, false, false, true] },
            ]);
            const filtered = data.filter((e) => e.priorDepartment == d);
            values.push(
              ...filtered.map((e) => [
                { alignment: "left", text: e.code },
                { alignment: "left", text: formatName(e.employee) },
                { alignment: "center", text: e.workedDays },
                { alignment: "right", text: formatMoney(e.salary) },
                {
                  alignment: "right",
                  text: formatMoney(e.salaryForPayroll),
                },
                { alignment: "right", text: formatMoney(e.overtime) },
                {
                  alignment: "right",
                  text: formatMoney(e.gratification),
                },
                {
                  alignment: "right",
                  text: formatMoney(e.subtotalSalary),
                },
                {
                  alignment: "right",
                  text: formatMoney(e.socialEmployee),
                },
                { alignment: "right", text: formatMoney(e.taxes) },
                { alignment: "right", text: formatMoney(e.discounts) },
                {
                  alignment: "right",
                  text: formatMoney(e.total),
                  bold: true,
                },
              ])
            );
            values.push([
              {
                border: [false, true, false, false],
                text: "Subtotal",
                bold: true,
                colSpan: 4,
                alignment: "right",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [false, true, false, false],
                text: formatMoney(
                  filtered.reduce((a, b) => a + b.salaryForPayroll, 0)
                ),
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, false, false],
                text: formatMoney(filtered.reduce((a, b) => a + b.overtime, 0)),
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, false, false],
                text: formatMoney(
                  filtered.reduce((a, b) => a + b.gratification, 0)
                ),
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, false, false],
                text: formatMoney(
                  filtered.reduce((a, b) => a + b.subtotalSalary, 0)
                ),
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, false, false],
                text: formatMoney(
                  filtered.reduce((a, b) => a + b.socialEmployee, 0)
                ),
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, false, false],
                text: formatMoney(filtered.reduce((a, b) => a + b.taxes, 0)),
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, false, false],
                text: formatMoney(
                  filtered.reduce((a, b) => a + b.discounts, 0)
                ),
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, false, false],
                text: formatMoney(filtered.reduce((a, b) => a + b.total, 0)),
                bold: true,
                alignment: "right",
              },
            ]);
          }

          const docDefinition = {
            pageSize: "LETTER",
            pageOrientation: "landscape",
            pageMargins: [20, 80, 20, 40],
            header: getHeader(
              "CALDER, SOCIEDAD ANÓNIMA",
              [paysheet.startDate, paysheet.endDate],
              `PLANILLA No. ${paysheet.code}`,
              "fixed",
              `REPORTE DE PLANILLA ORDINARIA`
            ),
            footer: getFooter(),
            content: [
              {
                style: "tableStyle",
                layout: {
                  defaultBorder: false,
                },
                table: {
                  headerRows: 1,
                  widths: [
                    "3.5%",
                    "*",
                    "3%",
                    "6.8%",
                    "6.8%",
                    "6.8%",
                    "6.8%",
                    "6.8%",
                    "6.8%",
                    "6.8%",
                    "6.8%",
                    "6.8%",
                  ],
                  body: [
                    [
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "COD.",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "NOMBRE COMPLETO",
                        bold: true,
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "DIAS",
                        bold: true,
                        alignment: "center",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "SALARIO",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "PLANILLA",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "H. EXTRA",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "GRATIFIC.",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "SUBTOTAL",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "IGSS",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "RENTA",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "DESCUEN.",
                        bold: true,
                        alignment: "right",
                      },
                      {
                        border: [false, false, false, true],
                        fontSize: 8,
                        text: "PAGO",
                        bold: true,
                        alignment: "right",
                      },
                    ],
                    ...values,
                    [
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: "TOTALES",
                        bold: true,
                        colSpan: 4,
                        alignment: "right",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: "",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: "",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: "",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: formatMoney(
                          data.reduce((a, b) => a + b.salaryForPayroll, 0)
                        ),
                        bold: true,
                        alignment: "right",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: formatMoney(
                          data.reduce((a, b) => a + b.overtime, 0)
                        ),
                        bold: true,
                        alignment: "right",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: formatMoney(
                          data.reduce((a, b) => a + b.gratification, 0)
                        ),
                        bold: true,
                        alignment: "right",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: formatMoney(
                          data.reduce((a, b) => a + b.subtotalSalary, 0)
                        ),
                        bold: true,
                        alignment: "right",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: formatMoney(
                          data.reduce((a, b) => a + b.socialEmployee, 0)
                        ),
                        bold: true,
                        alignment: "right",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: formatMoney(
                          data.reduce((a, b) => a + b.taxes, 0)
                        ),
                        bold: true,
                        alignment: "right",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: formatMoney(
                          data.reduce((a, b) => a + b.discounts, 0)
                        ),
                        bold: true,
                        alignment: "right",
                      },
                      {
                        margin: [0, 30, 0, 0],
                        border: [false, true, false, true],
                        text: formatMoney(
                          data.reduce((a, b) => a + b.total, 0)
                        ),
                        bold: true,
                        alignment: "right",
                      },
                    ],
                    [
                      {
                        colSpan: 12,
                        text: ".",
                      },
                    ],
                    [
                      {
                        colSpan: 12,
                        text: "",
                        margin: [0, 0, 0, 50],
                      },
                    ],
                    [
                      {
                        colSpan: 12,
                        layout: {
                          defaultBorder: false,
                        },
                        table: {
                          widths: [20, "*", 20, "*", 20, "*", 20],
                          body: [
                            [
                              "",
                              {
                                text: "ELABORADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "REVISADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                              {
                                text: "AUTORIZADO",
                                alignment: "center",
                                border: [false, true, false, false],
                              },
                              "",
                            ],
                          ],
                        },
                      },
                    ],
                  ],
                },
              },
            ],
            styles: {
              tableStyle: {
                fontSize: 7.5,
              },
            },
          };
          pdfMake.createPdf(docDefinition).open();
          break;

        case "excel":
          const filename = `planilla-ordinaria-${paysheet.code}-${format(
            new Date(),
            "YYYYMMDDHHmmss"
          )}`;
          const excelValues = [];

          for (const d of data) {
            excelValues.push({
              Codigo: d.code,
              NombreCompleto: formatName(d.employee),
              Departamento: d.priorDepartment,
              CentroCosto: d.employee.oldCostCenter
                ? d.employee.oldCostCenter.name
                : "",
              Dias: d.workedDays,
              Salario: parseFloat(d.salary.toFixed(2)),
              Planilla: parseFloat(d.salaryForPayroll.toFixed(2)),
              HExtra: parseFloat(d.overtime.toFixed(2)),
              Gratific: parseFloat(d.gratification.toFixed(2)),
              Subtotal: parseFloat(d.subtotalSalary.toFixed(2)),
              Isss: parseFloat(d.socialEmployee.toFixed(2)),
              Renta: parseFloat(d.taxes.toFixed(2)),
              Descuen: parseFloat(d.discounts.toFixed(2)),
              Pago: parseFloat(d.total.toFixed(2)),
            });
          }
          const worksheet = XLSX.utils.json_to_sheet(excelValues);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, worksheet, "Planilla ordinaria");
          XLSX.writeFile(wb, `${filename}.xlsx`);
          break;
      }
    },

    // PARA DATOS DE PLANILLA MENSUAL
    async openForPlanillaMensual() {
      axios
        .post("/", {
          query: `{
            paysheets (where: {active: false}) { id code startDate endDate year month sequence }
          }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            const paysheets = [];
            for (const p of data.paysheets) {
              const id = `${p.year}${p.month}`;
              const found = paysheets.find((py) => py.id == id);
              if (!found) {
                paysheets.push({
                  id,
                  code: `${this.meses
                    .find((m) => m.number == p.month)
                    .name.toUpperCase()} - 20${p.year}`,
                  data: [p],
                });
              } else {
                found.data.push(p);
              }
            }
            this.paysheets = paysheets
              .filter((p) => p.data.length > 1)
              .sort((a, b) => {
                if (a.id < b.id) return 1;
                if (a.id > b.id) return -1;
                return 0;
              });
            this.showPlanillaMensualDialog = true;
          }
        });
    },
    planillaMensualPaysheetChange(selectedOption) {
      this.planillaMensualDataLoading = true;
      const { data } = this.paysheets.find((p) => p.id == selectedOption);
      axios
        .post("/", {
          query: `{
            firstPH: paysheetHistory(where:{ paysheet: ${data[0].id} }) {
              id
              fullName
              workedDays
              missedDays
              salary
              salaryForPayroll
              overtime
              gratification
              discounts
              subtotalSalary
              taxes
              socialEmployee
              afpEmployee
              socialEmployer
              afpEmployer
              total
              code
              priorDepartment
              priorCostCenter
              employee { 
                name1, name2, name3, lastname1, lastname2, lastname3
                id documents { number documentType { shortName } } 
              }
            }
            secondPH: paysheetHistory(where:{ paysheet: ${data[1].id} }) {
              id
              fullName
              workedDays
              missedDays
              salary
              salaryForPayroll
              overtime
              gratification
              discounts
              subtotalSalary
              taxes
              socialEmployee
              afpEmployee
              socialEmployer
              afpEmployer
              total
              code
              priorDepartment
              priorCostCenter
              employee { 
                name1, name2, name3, lastname1, lastname2, lastname3
                id documents { number documentType { shortName } } 
              }
            }
            firstPAH: personalActionHistory(where:{ paysheet: ${data[0].id} }) {
              name
              value
              amount
              personalAction { id name baseSalary termination discount }
              employee { code }
              PAdeductISR
              type
            }
            secondPAH: personalActionHistory(where:{ paysheet: ${data[1].id} }) {
              name
              value
              amount
              personalAction { id name baseSalary termination discount }
              employee { code }
              PAdeductISR
              type
            }
          }`,
        })
        .then((res) => {
          const { data } = res.data;
          const employees = [];

          // recorre la primer quincena
          for (const e1 of data.firstPH) {
            employees.push({
              afpEmployee: e1.afpEmployee,
              afpEmployer: e1.afpEmployer,
              code: e1.code,
              discounts: e1.discounts,
              employee: e1.employee,
              fullName: e1.fullName,
              gratification: e1.gratification,
              id: e1.id,
              missedDays: e1.missedDays,
              overtime: e1.overtime,
              priorCostCenter: e1.priorCostCenter,
              priorDepartment: e1.priorDepartment,
              salary: e1.salary,
              salaryForPayroll: e1.salaryForPayroll,
              socialEmployee: e1.socialEmployee,
              socialEmployer: e1.socialEmployer,
              subtotalSalary: e1.subtotalSalary,
              taxes: e1.taxes,
              total: e1.total,
              workedDays: e1.workedDays,
            });
          }

          // recorre la segunda quincena
          for (const e2 of data.secondPH) {
            const found = employees.find(
              (e) => e.employee.id == e2.employee.id
            );
            if (!found) {
              employees.push({
                afpEmployee: e2.afpEmployee,
                afpEmployer: e2.afpEmployer,
                code: e2.code,
                discounts: e2.discounts,
                employee: e2.employee,
                fullName: e2.fullName,
                gratification: e2.gratification,
                id: e2.id,
                missedDays: e2.missedDays,
                overtime: e2.overtime,
                priorCostCenter: e2.priorCostCenter,
                priorDepartment: e2.priorDepartment,
                salary: e2.salary,
                salaryForPayroll: e2.salaryForPayroll,
                socialEmployee: e2.socialEmployee,
                socialEmployer: e2.socialEmployer,
                subtotalSalary: e2.subtotalSalary,
                taxes: e2.taxes,
                total: e2.total,
                workedDays: e2.workedDays,
              });
            } else {
              found.priorDepartment = e2.priorDepartment;
              found.priorCostCenter = e2.priorCostCenter;
              found.afpEmployee = found.afpEmployee + e2.afpEmployee;
              found.afpEmployer = found.afpEmployer + e2.afpEmployer;
              found.discounts = found.discounts + e2.discounts;
              found.gratification = found.gratification + e2.gratification;
              found.missedDays = found.missedDays + e2.missedDays;
              found.overtime = found.overtime + e2.overtime;
              found.salaryForPayroll =
                found.salaryForPayroll + e2.salaryForPayroll;
              found.socialEmployee = found.socialEmployee + e2.socialEmployee;
              found.socialEmployer = found.socialEmployer + e2.socialEmployer;
              found.subtotalSalary = found.subtotalSalary + e2.subtotalSalary;
              found.taxes = found.taxes + e2.taxes;
              found.total = found.total + e2.total;
              found.workedDays = found.workedDays + e2.workedDays;
            }
          }

          this.planillaMensualData = employees.map((h, index) => {
            const personalActions = data.firstPAH
              .concat(data.secondPAH)
              .filter((pa) => pa.employee.code == h.code);
            index = index + 1;
            return {
              index: index.toString(),
              ...h,
              workedDays: h.workedDays.toString(),
              gratificationsList: personalActions.filter((pa) => {
                return (
                  pa.value > 0 &&
                  !pa.personalAction.baseSalary &&
                  !pa.personalAction.termination &&
                  !pa.personalAction.discount
                );
              }),
              discountsList: personalActions.filter((pa) => pa.type == 3),
            };
          });
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(err.message);
        })
        .then((alw) => {
          this.planillaMensualDataLoading = false;
        });
    },
    generatePlanillaMensualReport(options) {
      const paysheet = this.paysheets.find(
        (p) => p.id == options.selectedPaysheet
      );

      const data = this.planillaMensualData;

      const filename = `planilla-mensual-${paysheet.code}-${format(
        new Date(),
        "YYYYMMDDHHmmss"
      )}`;

      const excelValues = [
        ["F.DATOS PLANILLAS DEL MES"],
        ["HORA Y FECHA DE EMISION"],
        ["EMPRESA: CALDER, SOCIEDAD ANÓNIMA"],
        [
          "DEPARTAMENTO",
          "CENTRO DE COSTO",
          "CODIGO",
          "NOMBRE",
          "DIAS",
          "TOTAL GRAVADO",
          "RENTA",
          "IGSS",
          "AFP",
          "AFP NOMBRE",
          "DUI",
          "SALARIO DEVENGADO",
          "TOTAL GRATIFIC.",
          "TOTAL GRATIFIC. EXENTAS",
          "HORAS EXTRA",
          "BONO",
          "COMISION",
          "CUMPLEAÑOS",
          "PREMIOS",
          "REINTEGROS",
          "VACACIONES",
          "DEPRECIACION",
          "VIATICOS",
          "DIAS NVO INGRESO",
          "DIAS INCAPACIDAD",
        ],
      ];
      const worksheet = XLSX.utils.aoa_to_sheet([
        ...excelValues,
        ...data.map((d) => {
          const dui = d.employee.documents.find(
            (d) => d.documentType.shortName == "DUI"
          );
          const afp = d.employee.documents.find(
            (d) =>
              ["afp confia", "afp crecer", "ipsfa"].includes(
                d.documentType.shortName.toLowerCase()
              ) &&
              d.number != "null" &&
              d.number != null &&
              d.number != ""
          );
          const totalGrat =
            d.gratificationsList
              .filter((g) =>
                [
                  "bono",
                  "comision",
                  "cumpleaños",
                  "premios",
                  "reintegros",
                  "dias incapacidad",
                  "dias nuevo ingreso",
                ].includes(g.name.trim().toLowerCase())
              )
              .reduce((a, b) => a + b.value, 0) + d.overtime;

          const totalDiasNuevoIngreso =
            d.gratificationsList
              .filter((g) =>
                ["dias nuevo ingreso"].includes(g.name.trim().toLowerCase())
              )
              .reduce((a, b) => a + b.value, 0) + d.overtime;
          return [
            d.priorDepartment,
            d.priorCostCenter,
            d.code,
            formatName(d.employee),
            parseFloat(d.workedDays),
            parseFloat(
              (totalGrat - totalDiasNuevoIngreso + d.salaryForPayroll).toFixed(
                2
              )
            ), // TOTAL GRAVADO
            parseFloat(d.taxes.toFixed(2)),
            parseFloat(d.socialEmployee.toFixed(2)),
            parseFloat(d.afpEmployee.toFixed(2)),
            afp.documentType.shortName, // AFP NOMBRE
            dui.number, // DUI
            parseFloat(d.salaryForPayroll.toFixed(2)), // SALARIO DEVENGADO
            parseFloat(totalGrat.toFixed(2)), // TOTAL GRATIFIC.
            parseFloat(
              d.gratificationsList
                .filter((g) =>
                  ["depreciacion", "viaticos"].includes(
                    g.name.trim().toLowerCase()
                  )
                )
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // TOTAL GRATIFIC. EXENTAS
            parseFloat(d.overtime.toFixed(2)), // HORAS EXTRA
            parseFloat(
              d.gratificationsList
                .filter((g) => g.name.trim().toLowerCase() == "bono")
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // BONO
            parseFloat(
              d.gratificationsList
                .filter((g) => g.name.trim().toLowerCase() == "comision")
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // COMISION
            parseFloat(
              d.gratificationsList
                .filter((g) => g.name.trim().toLowerCase() == "cumpleaños")
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // CUMPLEAÑOS
            parseFloat(
              d.gratificationsList
                .filter((g) => g.name.trim().toLowerCase() == "premios")
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // PREMIOS
            parseFloat(
              d.gratificationsList
                .filter((g) => g.name.trim().toLowerCase() == "reintegros")
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // REINTEGROS
            "", // VACACIONES
            parseFloat(
              d.gratificationsList
                .filter((g) => g.name.trim().toLowerCase() == "depreciacion")
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // DEPRECIACION
            parseFloat(
              d.gratificationsList
                .filter((g) => g.name.trim().toLowerCase() == "viaticos")
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // VIATICOS
            parseFloat(
              d.gratificationsList
                .filter(
                  (g) => g.name.trim().toLowerCase() == "dias nuevo ingreso"
                )
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // DIAS NVO INGRESO
            parseFloat(
              d.gratificationsList
                .filter(
                  (g) => g.name.trim().toLowerCase() == "dias incapacidad"
                )
                .reduce((a, b) => a + b.value, 0)
                .toFixed(2)
            ), // DIAS INCAPACIDAD
          ];
        }),
      ]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, worksheet, "Planilla mensual");
      XLSX.writeFile(wb, `${filename}.xlsx`);
    },
  },
};
</script>
